import '../types/externs'
import cache from './'

module.exports = cache